import * as Adaptive from 'adaptivecards';
import CustomHttpAction from '../cardActions/CustomHttpAction';
import * as ActionTypes from './adaptiveCardActionTypes';

export default function registerActions() {
    Adaptive.AdaptiveCard.actionTypeRegistry.unregisterType(ActionTypes.SUBMIT);
    Adaptive.AdaptiveCard.actionTypeRegistry.registerType(ActionTypes.HTTP, () => {
        return new CustomHttpAction(false);
    });
}
